import { Navigate, createFileRoute } from "@tanstack/react-router";

import { CmmdSyncPanel } from "../components/settings/CmmdSyncPanel";
import { useFeatureFlag } from "../hooks/useFeatureFlag";

function CmmdSettingsRoute() {
  const enabled = useFeatureFlag("cmmd_settings_sync_panel");
  if (!enabled) {
    // General, not Appearance: with the flag off this destination is hidden
    // from the rail entirely, so there is no reason to land on a page the user
    // did not ask for. General is where /settings itself goes.
    return <Navigate to="/settings/general" replace />;
  }
  return <CmmdSyncPanel />;
}

export const Route = createFileRoute("/settings/cmmd")({
  component: CmmdSettingsRoute,
});
